import { createAction, props } from '@ngrx/store';

export const updateMeasurementEquipmentRowVisibility = createAction(
    '[Forms] Update measuring equipment row visibility',
    props<{ rowId: string; visibility: boolean }>(),
);

export const disableMeasurementEquipmentTable = createAction(
    '[Forms] Disable measuring equipment table',
    props<{ rowId: string; noToolsUsed: boolean }>(),
);

export const updateMeasurementEquipmentSubmitSatus = createAction(
    '[Forms] Update measuring equipment table',
    props<{ submitStatus: boolean }>(),
);

export const updateMeasurementEquipmentColumnData = createAction(
    '[Forms] Update measuring equipment column data',
    props<{ columnId: string; rowId: string; value: string }>(),
);

export const updateMeasurementEquipmentsVisibility = createAction(
    '[Forms] Update measuring equipment visibility',
    props<{ visibility: boolean }>(),
);
